import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import clsx from "clsx"
import type { ReactNode } from "react"

import styles from "./RadioItem.module.css"

/** Private component */

interface RadioItemProps {
  value: string
  disabled: boolean
  children: ReactNode
  grow?: boolean
}

export function RadioItem(props: RadioItemProps) {
  const { value, disabled, children, grow = false } = props

  return (
    <RadioGroupPrimitive.Item
      value={value}
      disabled={disabled}
      className={clsx(styles.radioItem, grow && styles.grow)}
    >
      {children}
    </RadioGroupPrimitive.Item>
  )
}
